/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   SweetDeal helpers
 */

import { PropertyType } from '@zcode/enums'
import { getRecentPrice } from '../../../PriceChart/utils/getRecent'

import { LIST_CARD_SWEET_DEAL_THRESHOLD, SWEET_DEAL_THRESHOLD } from './constants'

export const getPercentMedianRentFromRecentAverages = ({ bedrooms, price, recentAverages }) => {
  if (!price || !bedrooms || !recentAverages) {
    return undefined
  }
  const recentPrice = recentAverages[bedrooms]
  if (recentPrice) {
    return Math.round(100 * (price / recentPrice))
  }
  return undefined
}

export const getPercentMedianRent = ({ entity, priceData }) => {
  if (!entity || !priceData) {
    return undefined
  }
  const { bedrooms, price } = entity
  const roomData = priceData[bedrooms]
  const seriesData = roomData && roomData.series
  const recentPrice = seriesData && getRecentPrice(seriesData)

  if (recentPrice) {
    const medianPriceRatio = Math.round(100 * (price / recentPrice))
    return medianPriceRatio
  }
  return undefined
}

export const isSweetDeal = (isBuilding, propertyType, percentMedianRent) => {
  return (
    !isBuilding && propertyType !== PropertyType.ROOM && percentMedianRent < SWEET_DEAL_THRESHOLD
  )
}

export const isSweetDealListCard = (isBuilding, propertyType, percentMedianRent) => {
  return (
    !isBuilding &&
    propertyType !== PropertyType.ROOM &&
    percentMedianRent < LIST_CARD_SWEET_DEAL_THRESHOLD
  )
}
